<template>
    <div v-if="!current_core_waybill.identity || current_store.current_job.core_waybill_scope == 'new'">

    </div>
    <!-- <CoreWaybill
        :core_waybill="empty_core_waybill"
        :template="'min_card'"
        :is_inverted="is_inverted"
        :is_auto_print="false"
        :is_can_update="false"
        :is_can_print_label="false"
        :is_show_change_template_btns="false"
        :card="{
            is_half_style: true,
            is_show_note: false,
        }"
        >
    </CoreWaybill> -->
    <div v-else>
        <CoreWaybill
            :core_waybill="current_core_waybill"
            :template="tool_core_waybill_settings.template"
            :scope="$store.state.current_scope"
            :is_inverted="is_inverted"
            :is_in_scanner_modal="true"
            :is_show_change_template_btns="tool_core_waybill_settings.is_show_change_template_btns"
            :is_force_print="true"
            :is_auto_print="tool_core_waybill_settings.is_auto_print"
            :is_small_label="tool_core_waybill_settings.is_small_label"
            :label_src="tool_core_waybill_settings.label_src"
            :label_paper_type="tool_core_waybill_settings.label_paper_type"
            :is_can_print_label="tool_core_waybill_settings.is_print_label"
            :is_can_update="tool_core_waybill_settings.is_update_corewaybill"
            :can_update_field_names="(current_setting_group.barcode == 'LA04') ? ['receipt_file_url'] : []"
            :cant_update_field_names="tool_core_waybill_settings.cant_update_field_names"
            :card="{
                is_half_style: true,
                is_simple_form: false,
                is_vertical: is_vertical,
                is_show_note: true,
            }"
            :detail="{
                is_show_blood_related: true,
                is_show_receipt_file: true,
                is_show_partition: true,
                is_show_statuses: true,
            }"
            style="margin: 0px;"
            >
        </CoreWaybill>
    </div>
</div>

</template>

<script>
import CoreWaybill from '@toolbox/core_waybill/main.vue'

export default {
    components: {
        CoreWaybill,
    },
    props: {
        current_core_waybill: Object,
        current_scan_action_prototype: Object,
        is_inverted: {
            default: false,
            type: Boolean
        },
        fetch_core_waybill_statuses: {
            default: false,
            type: Boolean
        },
        card_button_color: {
            default: "",
            type: String,
        },
        card_button_content: {
            default: "",
            type: String,
        },
        card_button_channel: {
            default: "",
            type: String,
        },
        file_uploader: {
            default: false,
            type: Boolean
        },
        focus_field: {
            default: "",
            type: String
        },
        related_columns: {
            // [{
            //     is_required: false
            //     name: "original_number"
            // },{...}]
            default: () => { return [] },
            type: Array
        },
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        style() {
            return this.$store.state.style
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
        settings() {
            return this.current_store.settings
        },
        current_setting_group() {
            return this.current_store.current_setting_group
        },
    },
    data() {
        return {
            is_initialized: false,
            is_vertical: false,
            tool_core_waybill_settings: {
                cant_update_field_names: [],
                is_show_change_template_btns: true,
                is_update_corewaybill: false,
                is_print_label: false,
                is_auto_print: false,
                template: "card",
                label_src: "",
                label_paper_type: null,
            },
            core_waybill_template_mode: "",
            core_waybill_statuses: [],
            empty_core_waybill: {
                "number": "請輸入號碼"
            },

            tool_core_waybill_active_button: {
                content: "",
                channel: ""
            },
        }
    },
    mounted() {
        this.init()

        // check_is_vertical
        this.is_vertical = (this.style.width <= 767)
            ? true
            : false ;

        $(window).resize(() => {
            this.is_vertical = (this.style.width <= 767)
                ? true
                : false ;
        });
    },
    watch: {
        'settings.core_waybill_template_mode'(value) {
            // 切換template時 關閉自動產標
            this.tool_core_waybill_settings.template = (this.current_setting_group.barcode == 'LA02') ? 'waybill' : value
            this.tool_core_waybill_settings.is_auto_print = false
        },
        current_core_waybill() {
            this.init()
        },
    },
    methods: {
        async init() {
            this.is_initialized = false

            await this.set_tool_core_waybill_settings()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        set_tool_core_waybill_settings() {
            this.tool_core_waybill_settings.label_src = ""
            this.tool_core_waybill_settings.label_paper_type = null
            this.tool_core_waybill_settings.is_show_change_template_btns = true
            this.tool_core_waybill_settings.is_update_corewaybill = this.settings.is_update_core_waybill_mode
            this.tool_core_waybill_settings.is_small_label = this.settings.is_print_small_label_of_any_number_mode
            this.tool_core_waybill_settings.is_auto_print = this.settings.is_auto_print_label_mode

            this.tool_core_waybill_settings.template = (this.$store.getters[this.$store.state.current_scope+'/scanner_module/current_core_waybill_need_related_columns'].length)
                ? 'card'
                : this.settings.core_waybill_template_mode

            //  LA02: 進站, 強迫show 標籤, 列印標籤按紐
            if (this.current_setting_group.barcode == 'LA02') {
                this.tool_core_waybill_settings.template = 'waybill'
                this.tool_core_waybill_settings.is_print_label = true
                // this.tool_core_waybill_settings.is_auto_print = true

            } else {
                this.tool_core_waybill_settings.template = this.settings.core_waybill_template_mode
                this.tool_core_waybill_settings.is_print_label = this.settings.is_auto_print_label_mode
            }

            // 若有必填欄位 必取消 自動產標
            this.tool_core_waybill_settings.is_auto_print = (this.$store.getters[this.$store.state.current_scope+'/scanner_module/current_core_waybill_need_related_columns'].length)
                ? false
                : this.tool_core_waybill_settings.is_auto_print

            // 列印小標的
            if (this.settings.is_print_small_label_of_any_number_mode) {
                let label_height = 39 // 40
                let label_width = 79 // 80
                this.tool_core_waybill_settings.is_show_change_template_btns = false
                this.tool_core_waybill_settings.label_paper_type = `${label_height}x${label_width}`
                this.tool_core_waybill_settings.is_print_label = true
                this.tool_core_waybill_settings.template = "min_card"
                this.current_core_waybill.label_type = "Label::Default"
                this.tool_core_waybill_settings.label_src = this.get_small_label_src(label_height, label_width)
            }
            return Promise.resolve()
        },
        get_small_label_src(label_height = 100, label_width = 100) {
            try {
                // 範例
                // local.mynet.com.tw:3000/v1/provider/papers/print.svg?paper_size=30x100&template=1x1&contents=[{"core_waybill_number":"X515431","printing_type":"Label::Default","label_height":"30","label_width":"100","is_hide_tw568_barcode":"true"}]&authorization=eyJhbGciOiJIUzI1NiJ9.eyJwcm92aWRlcl9ub2RlX2lkZW50aXR5IjoiN2NiMDYyNWMxNi0yODAzNi0zOTc2ODI5MiIsImN1c3RvbWVyX2lkZW50aXR5IjpudWxsLCJzdGFmZl9pZGVudGl0eSI6IjY2NDRkODhjZTNjZjkxM2QtMjgwMzYtMTc0MjI0ODM2MCIsInN0YXRpb25faWRlbnRpdHkiOm51bGwsImNvbnRyYWN0X2lkZW50aXR5IjpudWxsLCJyb2xlIjoic3RhZmYifQ.rE9c2s62qONq0jkt37tdH_HuMD7QK8jZoZxyXAJ6DJ0
                let parameters = `.svg?paper_size=${label_height}x${label_width}` +
                    `&template=1x1` +
                    `&authorization=${this.get_authentication_token()}`

                let contents = [{
                    core_waybill_number: this.current_core_waybill.number,
                    number: this.current_core_waybill.number,
                    tracking_number: this.current_core_waybill.tracking_number,
                    printing_type: this.get_label_printing_type(),
                    label_height: label_height,
                    label_width: label_width,
                }]
                let base_url = this.get_papers_print_api_url() + parameters

                return this.get_papers_print_api_url() + parameters + `&contents=${JSON.stringify(contents)}`
            } catch (e) {
                return ""
            }
        },
        get_label_printing_type() {
            let node = this.get_current_provider_node()
            if (!node) return "Label::Default"

            switch (node.identity) {
                case '53e998d97c9b78e7-28036-39768292': // 協錸運
                    return "Label::Condor"
                    break
                default:
                    return "Label::Default"
            }
        },
        get_current_provider_node() {
            return this.$store.state.current_scope == 'provider'
                ? this.$store.state.provider.node
                : this.$store.state.customer.customer.provider_node
        },
        get_papers_print_api_url() {
            switch (this.$store.state.current_scope) {
                case 'provider':
                    return this.$store.state.provider.routes.api_v1_provider_papers_print
                    break
                case 'customer':
                    return this.$store.state.customer.routes.api_v1_customer_papers_print
                    break

                default:
                    return this.$store.state.provider.routes.api_v1_provider_papers_print
            }
        },
        get_authentication_token() {
            switch (this.$store.state.current_scope) {
                case 'provider':
                    return localStorage.getItem("authentication_token")
                    break
                case 'customer':
                    return localStorage.getItem("customer_authentication_token")
                    break

                default:
                    return localStorage.getItem("authentication_token")
            }
        },
    },

}
</script>

<style lang="scss" scoped>
    .segments.core_waybill.half {
        margin: 0 auto !important;
        float: inherit !important;
    }
    .detail.core_waybill {
        margin: 0 30px;
        border-radius: .28571429rem;
    }
</style>
